<!--
*************
** Default **
*************
-->
<!--<ng-container *ngIf="!data.subscription">-->

<!--    <div *ngIf="data.highlight" class=" circle highlight text-center d-flex align-items-center justify-content-center">-->
<!--        <span [innerHTML]="data.highlight"></span>-->
<!--    </div>-->
<!--        <button class="btn btn-primary m-0 position-absolute " style="bottom:30px; left:30px" mat-button [mat-dialog-close]="false" (click)="onButtonClick()">{{data.button}}</button>-->
<!--<div class="dialog-top position-relative mb-xl">-->
<!--<img src="{{data.image}}" alt="{{data.image_alt}}"/>-->
<!--</div>-->
<!--        <button class="close" type="button" [mat-dialog-close]="true"><i class="fal fa-times"></i></button>-->

<!--<h1 mat-dialog-title class="pb-0 survey-title" [innerHTML]="data.title"></h1>-->
<!--<p [innerHTML]="data.title"></p>-->
<!--<div mat-dialog-content>-->
<!--    <p [innerHTML]="data.body"></p>-->
<!--  <p>Profitieren Sie schon heute von der digitalen Belegbereitstellung.<sup>*</sup></p>-->
<!--  <p><img src="../../assets/img/icons/package-fast.svg" alt="" width="40">&nbsp;&nbsp;&nbsp;Schnellere und präzisere Bestellabwicklung</p>-->
<!--  <p><img src="../../assets/img/icons/list.svg" alt="" width="40">&nbsp;&nbsp;&nbsp;Archivierung wichtiger Dokumente</p>-->
<!--  <p><img src="../../assets/img/icons/world.svg" alt="" width="40">&nbsp;&nbsp;&nbsp;Gemeinsam Nachhaltigkeit für eine grünere Zukunft</p>-->
<!--  <p>Rufen Sie in Ihrem PHOENIX Kunden-Service-Center an und wir veranlassen für Sie gerne die sofortige Deaktivierung-->
<!--    der physischen Lieferscheinbeigabe.</p>-->
<!--</div>-->

<!--<div mat-dialog-actions class="text-center my-4 d-flex justify-content-center align-items-center" *ngIf="data.button">-->
<!--    <button class="btn btn-primary mt-0 btn-special">{{data.button}}</button>-->
<!--    <button class="btn btn-primary mt-0" mat-button [mat-dialog-close]="false" (click)="onButtonClick()">{{data.button}}</button>-->
<!--    <button class="btn btn-secondary" mat-button [mat-dialog-close]="true">Schließen</button>-->
<!--</div>-->

<!--<p *ngIf="data.disclaimer" class="disclaimer" [innerHTML]="data.disclaimer"></p>-->
<!--</ng-container>-->
<!--

*****************************
** POPUP WITH PDF DOWNLOAD **
*****************************
-->
@if (!data.subscription && data.title !== 'UPDATE') {
  <div class="dialog-top position-relative dialog-popup" (click)="onImageClick(data.image_alt)" style="cursor: pointer" [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type" >
    <img src="{{data.image}}" alt="{{data.image_alt}}"/>
    <!--     <div *ngIf="data.highlight" class=" circle highlight text-center d-flex align-items-center justify-content-center">-->
    <!--     <span [innerHTML]="data.highlight"></span>-->
  </div>
  <!--<h2 class="mt-xxl mb-0" [innerHTML]="data.title" *ngIf="data.title"></h2>-->
  <!--<div mat-dialog-content>-->
  <!--<p [innerHTML]="data.body" *ngIf="data.body"></p>-->
<!--</div>-->
@if (data.button) {
  <div mat-dialog-actions class="text-center my-4 d-flex justify-content-center align-items-center">
    <button class="btn btn-primary cursor-pointer mt-0" mat-button [mat-dialog-close]="false" (click)="onImageClick(data.image_alt)">{{data.button}}</button>
  </div>
}
}

<!--
****************************
** POPUP WITH SUB/OPT-OUT **
****************************
-->
@if (data.subscription) {
  @if (!subscribed) {
    <div class="dialog-top dialog-popup" (click)="redirect()"  [ngClass]="cursorStyle" [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type">
      <img src="{{data.image}}" alt="{{data.image_alt}}">
      <!--    <div class="circle highlight text-center d-flex align-items-center justify-content-center">-->
      <!--        <span [innerHTML]="data.highlight"></span>-->
    <!--    </div>-->
    <!--    <button class="close" type="button" [mat-dialog-close]="true"><i class="fal fa-times"></i></button>-->
  </div>
  @if (data.title) {
    <h2 class="mt-xxl mb-0" [innerHTML]="data.title"></h2>
  }
  @if (data.body) {
    <div mat-dialog-content>
      <p [innerHTML]="data.body"></p>
    </div>
  }
  @if (data.button) {
    <div mat-dialog-actions class="text-center my-4 d-flex justify-content-center align-items-center">
      <button class="btn btn-primary cursor-pointer mt-0" [mat-dialog-close]="false" (click)="onSubscribe(data.image_alt)">{{data.button}}</button>
    </div>
  }
  <!--    <div mat-dialog-title>-->
  <!--      <h4 class="phx-corporate" [innerHTML]="data.title"></h4>-->
<!--    </div>-->
<!--        <h2 class="mt-xxl phx-corporate text-center" [innerHTML]="data.title"></h2>-->
<!--    <p class="text-center">-->
<!--      Aufgrund einer aktualisierten Version der DATEV Schnittstelle ist eine erneute Bestätigung der Zugriffsberechtigung auf Ihren Bestand erforderlich. Mit der von Ihnen genutzten alten Version können ab April 2024 keine PHOENIX Belege mehr an DATEV übertragen werden.-->
<!--    </p>-->
<!--    <p class="text-center text-danger"><strong>Bestätigen Sie einmalig Ihre DATEV Berechtigungen bis zum 31.03.2024!</strong></p>-->
<!--    <div mat-dialog-actions class="mb-s  d-flex justify-content-center">-->
<!--      <button class="btn-primary" mat-button (click)="onSubscribe(data.image_alt)">-->
<!--        <span>Jetzt bestätigen</span>-->
<!--&lt;!&ndash;        <i class="material-icons">&ndash;&gt;-->
<!--&lt;!&ndash;          check&ndash;&gt;-->
<!--&lt;!&ndash;        </i>&ndash;&gt;-->
<!--      </button>-->
<!--      <button class="btn-secondary" mat-button (click)="onOptOut(data.image_alt)">-->
<!--        <span>Später erinnern</span>-->
<!--&lt;!&ndash;        <i class="material-icons">&ndash;&gt;-->
<!--&lt;!&ndash;          close&ndash;&gt;-->
<!--&lt;!&ndash;        </i>&ndash;&gt;-->
<!--      </button>-->
<!--    </div>-->
}
<!--  <ng-container *ngIf="subscribed">-->
<!--    <p class="phx-cta mt-m"><b>Vielen Dank für Ihren Antrag!<br>-->
<!--      Wir werden die Umstellung auf die elektronische Sammelrechnung-->
<!--      zum nächsten Monatswechsel durchführen</b></p>-->
<!--  </ng-container>-->
}

<!--
****************************************
** PUSH NOTIFICATION WITH SUB/OPT-OUT **
****************************************
-->

@if (!data.subscription && data.title === 'UPDATE') {
  <div [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type" class="dialog-popup">
    <!--  <div class="d-flex align-items-center mb-l">-->
    <!--    <i class="fal fa-sync phx-corporate mr-3 updateIcon"></i>-->
    <!--    <h2 class="text-to-crop" [innerHTML]="data.title"></h2>-->
  <!--  </div>-->
  <div class="dialog-update-header">
    <h2>UPDATE</h2>
  </div>
  <h2 class="text-to-crop">Ihr PHOENIX Apothekenportal wird aktualisiert.</h2>
  <p>Bitte warten Sie, bis die Installation abgeschlossen ist. Anschließend können Sie das Fenster schließen und die neuen Funktionen nutzen.</p>
  <div mat-dialog-content>
    <div class="d-flex align-items-center">
      <mat-progress-bar mode="determinate" color="accent" [value]="progress" class="my-xl"></mat-progress-bar>
      <h6 class="loadingPercentage" [ngStyle]="{'left': progress + '%'}">{{progress}}%</h6>
      @if (progress < 100) {
        <small class="ml-m phx-corporate font-weight-bold">Laden...</small>
      }
    </div>
    <div>
    </div>
    <h6 class="updateHead">NEU IN DER SENDUNGSVERFOLGUNG:</h6>
    <ul class="check-list mb-0">
      @for (content of listItems ; track content; let i = $index) {
        <li [innerHTML]="content | safeHtml"></li>
      }
    </ul>
    @if (progress < 100) {
      <div class="dotLoader"></div>
    }
  </div>
  <div mat-dialog-actions class="mb-s  d-flex justify-content-end">
    <!--    <button class="btn btn-secondary" [mat-dialog-close]="true" (click)="onSubscribe('show video')" [disabled]="progress < 100" ><span class="fal fa-film fa-1-5-x"></span> neuerungen ansehen ></button>-->
    <button class="btn btn-primary" [mat-dialog-close]="true" (click)="onSubscribe('update')" [disabled]="progress < 100" >{{data.button}}</button>
  </div>
  @if (data.disclaimer) {
    <p class="disclaimer" [innerHTML]="data.disclaimer"></p>
  }
</div>
}
